var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"","on-remove":_vm.handleRemove,"http-request":_vm.upload,"file-list":_vm.explainFileList,"on-preview":_vm.handlePreview,"multiple":""}},[_c('el-button',{attrs:{"size":"small","icon":_vm.icon}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }